import { render, staticRenderFns } from "./siteAdminForm.vue?vue&type=template&id=ff36fac4&scoped=true&"
import script from "./siteAdminForm.vue?vue&type=script&lang=js&"
export * from "./siteAdminForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff36fac4",
  null
  
)

export default component.exports